<template>
    <div
        class="loading-circle"
        :class="{ large }"
    >
        <span />
    </div>
</template>

<script setup lang="ts">
defineProps<{
    large?: boolean
}>()
</script>

<style lang="sass" scoped>
@import "./LoadingCircle.sass"
</style>
